import { l, lreplace } from '@utils/toolbox';
export default function isFlightAboveEconomy (journey) {
	return journey?.cabin !== 0 && !journey?.mixedCabinType;
}


export function getPassengersText (passengers, isYouth = false, useHtml = false) {
	const format = (count, label) => useHtml
		? `${count} <small>${label}</small>`
		: `${count} ${label}`;

	const count = isYouth ? passengers?.youth?.count : passengers?.adults;
	const label = isYouth
		? count > 1
			? l('searchBox.passengers.youthPlural')
			: l('searchBox.passengers.youth')
		: count > 1
			? l('searchBox.passengers.adults')
			: l('searchBox.passengers.adult');

	if (isYouth) {
		return count > 0 ? format(count, label) : '';
	}

	const children = passengers?.child?.ages?.length;
	const childrenLabel = children > 1
		? l('searchBox.passengers.children')
		: l('searchBox.passengers.child');

	return [
		count > 0 ? format(count, label) : '',
		children > 0 ? format(children, childrenLabel) : ''
	].filter(Boolean).join(' ');
}


export function getTicketClassText (ticketClassCode, journey) {
	const ticketClassTextByCode = {
		1: l('searchBox.ticketType.business'),
		2: l('searchBox.ticketType.firstClass'),
		3: l('searchBox.ticketType.premium')
	};

	const economyText = l('searchBox.ticketType.economy');
	const getClassText = code => ticketClassTextByCode[code] ?? economyText;

	if (journey?.mixedCabinType) {
		return lreplace('searchBox.ticketType.combined', { cabin: getClassText(journey.cabin) });
	}

	return getClassText(ticketClassCode);
}
